// app/javascript/components/submission_boards/component/PreferredBy.tsx
import React, { useState, useRef, useEffect } from 'react';
// import { Star } from '@heroicons/react/24/outline';
import {
  getUserBgColorsRandom,
  getUserColorsRandom,
  RecipientProfileStatusMaster,
  SubmissionBoardModel,
} from './SbModel';
import { CircleUserRoundIcon, Star, ShapesIcon } from 'lucide-react';
import { UserCircleIcon } from '@heroicons/react/20/solid';

interface UserIconProps {
  imageUrl: string;
  name: string;
  index: number;
}

const UserIcon: React.FC<UserIconProps> = ({ imageUrl, name, index }) => {
  const [imageUrlSelected, setImageUrlSelected] = useState<string>('');

  const componentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setImageUrlSelected(imageUrl);
  }, [imageUrl]);

  return (
    <>
      {imageUrlSelected && imageUrlSelected != '' ? (
        <img
          src={imageUrlSelected}
          alt={name}
          className="w-full h-full object-cover"
          onError={(e) => {
            // e.currentTarget.src =
            // This will log an error if the image fails to load
            console.error('Image failed to load:', imageUrlSelected, e);
            setImageUrlSelected('');
          }}
        />
      ) : (
        <div
          className="w-full h-full"
          style={{
            backgroundColor: getUserBgColorsRandom(index),
            color: getUserColorsRandom(index),
          }}
        >
          <CircleUserRoundIcon className="w-full h-full" />
        </div>
        // <span className="text-xs text-gray-700">{user.name.charAt(0).toUpperCase()}</span>
      )}
    </>
  );
};

export default UserIcon;
